<template>
  <div id="allCheckTender">
    <div class="search">
      <el-form ref="form" :model="form" label-width="90px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="招标人" prop="tenderee">
              <el-input
                v-model="form.tenderee"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="申请人" prop="applicant">
              <el-input
                v-model="form.applicant"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="发布时间">
              <el-date-picker
                class="select"
                v-model="form.starttime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label-width="10px">
              <el-date-picker
                class="select"
                v-model="form.endtime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="投标状态">
              <el-select
                v-model="form.status"
                placeholder="请选择"
                class="select"
                clearable
              >
                <el-option
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="primary" @click="GetSearch">搜索</el-button>
              <el-button @click="reset('form')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="是否开发票">
                <el-select v-model="form.invoice" placeholder="请选择" class="select">
                  <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否结案">
                <el-select v-model="form.closecase" placeholder="请选择" class="select">
                  <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否归档">
                <el-select v-model="form.file" placeholder="请选择" class="select">
                  <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
      </el-form>
    </div>

    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="tenderee" label="招标人"> </el-table-column>
        <el-table-column prop="procurefile" label="采购文件名称">
        </el-table-column>

        <el-table-column prop="applicant" label="申请人"> </el-table-column>
        <el-table-column prop="publishDate" label="发布时间">
          <template slot-scope="scope" v-if="scope.row.publishDate">
            {{ handleTime(scope.row.publishDate) }}
          </template>
        </el-table-column>
        <el-table-column label="当前状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" type="text" class="spz"
              >审批中</span
            >
            <span v-if="scope.row.status == 2" type="text" class="fail"
              >被驳回</span
            >
            <span v-if="scope.row.status == 0" type="text" class="pass"
              >通过</span
            >
            <span v-if="scope.row.status == -1" type="text" class="del"
              >已撤销</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="scope">
            <!-- <el-button class="tg" size="small" @click="approval(scope.row.id,0)">通过</el-button>
                        <el-button class="bh" size="small" @click="approval(scope.row.id,1)">驳回</el-button> -->
            <!-- <el-button
              class="look"
              size="small"
              @click="Look(scope.row.id)"
              v-if="$store.state.rolesname.includes('Biddetail')"
              >查看</el-button
            > -->
            <el-button class="look" size="small" @click="Look(scope.row.id)"
              >查看</el-button
            >
            <!-- <el-button
              v-if="
                scope.row.status == 1 &&
                $store.state.rolesname.includes('allCheckTender_del')
              "
              class="delbtn"
              size="small"
              @click="del(scope.row.id, 4)"
              >撤销</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>

      <div class="bank_pagination">
        <el-pagination
          :hide-on-single-page="value"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!--更多选择!-->
    <el-dialog
      title="搜索"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
    >
      <el-form ref="form" :model="form" label-width="90px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="招标人" prop="tenderee">
              <el-input
                v-model="form.tenderee"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请人" prop="applicant">
              <el-input
                v-model="form.applicant"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="发布时间">
              <el-date-picker
                class="select"
                v-model="form.starttime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10px">
              <el-date-picker
                class="select"
                v-model="form.endtime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="投标状态">
              <el-select
                v-model="form.status"
                placeholder="请选择"
                class="select"
              >
                <el-option
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="是否开发票">
                <el-select v-model="form.invoice" placeholder="请选择" class="select">
                  <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否结案">
                <el-select v-model="form.closecase" placeholder="请选择" class="select">
                  <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否归档">
                <el-select v-model="form.file" placeholder="请选择" class="select">
                  <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="GetSearch">搜索</el-button>
        <el-button @click="reset('form')">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { Tender, Upadte, allCheckTender } from '../../api/tender'

export default {
  name: 'allCheckTender',
  data() {
    return {
      // next: true,//是否是三级菜单,
      next: false, //是否是三级菜单
      Con: '',
      more: '',

      dialogVisible: false,
      form: {
        tenderee: '',
        applicant: '',
        endtime: null,
        starttime: null
        // status:null,
      },
      Status: [
        { label: '已通过', value: 0 },
        { label: '待审核', value: 1 },
        { label: '驳回', value: 2 },
        { label: '撤销', value: -1 }
      ],
      // CaseType:[{ label: "已通过", value: 0 }, { label: "一审", value: 1 }],
      dialogVisible: false, //弹出框
      IsorNo: [
        { label: '是', value: 0 },
        { label: '否', value: 1 }
      ],
      // Casetype:[{ label: "民事案件", value: "民事案件" }, { label: "破产案件", value: "破产案件" }],
      tableData: [],
      PageSizes: [10, 20, 50, 100],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      value: false //只有一页的时候隐藏分页
    }
  },

  methods: {
    del(id, status) {
      this.$confirm('此操作将撤回申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          Upadte({ Id: id, Status: status }).then((res) => {
            if (res.data.status == 'success') {
              this.$message({
                type: 'success',
                message: '撤回成功!'
              })
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
            this.Search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销'
          })
        })
    },
    Look(id) {
      //查看
      this.$router.push({
        path: '/home/seal/BidApprovedetail',
        query: {
          guid: id,
          dayin: false
        }
      })
    },
    reset() {
      this.form.tenderee = ''
      this.form.applicant = ''
      // this.form.status=null;
      this.form.starttime = null
      this.form.endtime = null
    },
    GetSearch() {
      this.PageIndex = 1
      this.Search()
    },
    Search() {
      var starttime = null
      var endtime = null
      if (this.form.starttime) {
        starttime = this.JsonTime(this.form.starttime)
      }
      if (this.form.endtime) {
        endtime = this.JsonTime(this.form.endtime)
      }
      allCheckTender({
        page: this.PageIndex,
        rows: this.PageSize,
        Tenderee: this.form.tenderee,
        Applicant: this.form.applicant,
        Status: this.form.status,
        StartTime: starttime,
        EndTime: endtime
      }).then((res) => {
        if (res.data.status == 'success') {
          this.tableData = res.data.data
          this.Total = res.data.total
          this.dialogVisible = false
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogVisible = true
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.Search()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.Search()
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd
      var t = new Date(time)
      var time = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
      return time
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    },
    getvalue() {
      //传值给父组件，
      //判断有没有审核权限，有的话该页面是三级页面，没有为二级页面
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/seal' //遍历每一个数组，过滤出返回值委true的值
      )
      var arr = target[0].children.filter(
        //查询审核权限
        (el) => el.path == 'BidApprove'
      )
      if (arr.length <= 0) {
        //没有用章审核权限
        this.next = false //该页面不为三级页面
      }
      this.$emit('value', this.next)
    }
  },
  created() {
    this.getvalue()
    this.Search()
  }
}
</script>
  
<style lang="less" scoped>
// 查询
#allCheckTender .search {
  box-sizing: border-box;
  width: 100%;
  // margin: auto;
  // display: flex;

  padding: 20px;
  // margin-bottom: 24px;
}

#allCheckTender .search ::v-deep .el-input__inner {
  // width: 80% !important;
  // width: 300px;
  background-color: #fafafa;
  border: 0 !important;
  border-radius: 12px;
}

#allCheckTender .nameSearch {
  width: 24vw;
  margin-right: 10px;
}

// #allCheckTender .select {
//   width: 10vw;
//   margin-right: 10px;
// }

// 弹出框
#allCheckTender /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

.btn {
  width: 100%;
  text-align: center;
}

//表格
#allCheckTender .casestatus {
  color: rgba(254, 150, 74, 1);
}

#allCheckTender .pass {
  color: #3077e6;
}

#allCheckTender .spz {
  color: #0caf60;
}

#allCheckTender .fail {
  color: #fe964a;
}

#allCheckTender .del {
  color: red;
}

#allCheckTender .look {
  background: #eff5ff;
  border-radius: 8px;
  color: #3077e6;
  border: none;
}

#allCheckTender .delbtn {
  background: #fff0e6;
  border-radius: 8px;
  color: #fe964a;
  border: none;
}

// 分页
#allCheckTender .bank_pagination {
  text-align: right;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

#allCheckTender /deep/.el-pagination__total {
  float: left;
}

/deep/.el-pagination__sizes {
  float: left;
}
</style>
  